/**
 * JSON 解析的统一出口。
 *
 * 为什么需要它：后端字段、localStorage、SSE 报文都可能为空、被截断或被人为改写，
 * 裸调用 JSON.parse 抛出的 SyntaxError 会一路冒泡——在渲染函数里会中断整个组件的
 * 渲染，在流式回调里会打断后续消息。《代码安全开发规范》第 8.2 节要求对可能抛错的
 * 解析做异常处理，这里收成一个出口，调用方只需给一个语义明确的兜底值。
 *
 * 注意：解析失败按「拿不到数据」处理并返回兜底值，不重新抛出。需要区分「解析失败」
 * 与「值就是 null」的场景，请自行传入可区分的 defaultValue。
 */

/**
 * 安全解析 JSON 字符串。
 * @param {*} raw 待解析内容；非字符串（已是对象、undefined 等）直接返回兜底值
 * @param {*} [defaultValue] 解析失败或结果为空时的兜底值，默认 null
 * @returns {*} 解析结果；失败时为 defaultValue
 */
export const safeJsonParse = (raw, defaultValue = null) => {
  if (typeof raw !== 'string' || !raw.length) return defaultValue
  try {
    const parsed = JSON.parse(raw)
    // 只有 null / undefined 才回落到兜底值，false 与 0 都是合法结果
    return parsed ?? defaultValue
  } catch (error) {
    return defaultValue
  }
}
